import React, { memo } from 'react'
import Zendesk from 'react-zendesk'

const ZendeskWidget = () => {
  const zendeskKey = process.env.REACT_APP_ZENDESK_KEY
  return zendeskKey && <Zendesk defer zendeskKey={zendeskKey} />
}

export default memo(ZendeskWidget)
